// @flow
import * as React from 'react';

export const loadSteps = (
  filename: string,
  children: Array<React.Element<any>>,
): ?React.Element<any> =>
  children.find((child) => child.props?.file?.includes(`steps/${filename}`));
